import React, { useContext, useEffect, useState } from 'react';

import { useAnalyticsContext } from 'app/shared/utils';
import { enabledForEventOrganizedAs } from 'app/shared/utils/events';
import { Event } from 'app/shared/typings';
import { ModalStep } from 'app/shared/typings/auth';
import { useMultiStepSignUpContext } from 'app/shared/context';
import { AuthContext } from 'app/shared/context/Auth';
import { MultiStepSignUpWizard } from 'app/shared/components/organisms';
import { setSmsPopupDismissedCookie } from 'app/fan/utils/cookieSetters';

interface SmsSignUpModalProps {
  event: Event;
  sofarStarted: boolean;
}

export const SmsSignUpModal: React.FC<
  React.PropsWithChildren<SmsSignUpModalProps>
> = ({ event, sofarStarted }) => {
  const { loggedIn, user } = useContext(AuthContext);
  const { smsMarketingSignUpForm } = useMultiStepSignUpContext();
  const { trackAnalyticsEvent } = useAnalyticsContext();

  const { shouldDisplaySmsOptIn } = smsMarketingSignUpForm({
    formContext: 'sms-sign-up-modal-form',
    checkSmsPopupCookie: true,
    checkIsAccountOlderThanThirtyDays: true,
    hide: sofarStarted,
  });
  const [smsSignUpModalFired, setSmsSignUpModalFired] = useState(false);
  const [isMultiStepSignUpShowing, setIsMultiStepSignUpShowing] =
    useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const showSmsOptIn =
      enabledForEventOrganizedAs(event.eventOrganizedAs, 'smsSignup') &&
      shouldDisplaySmsOptIn;

    if (!smsSignUpModalFired && !isMultiStepSignUpShowing && showSmsOptIn) {
      setIsMultiStepSignUpShowing(true);
      setSmsSignUpModalFired(true);
      trackAnalyticsEvent('SMS Opt-In Displayed', {
        form_context: 'event-page-logged-in-modal',
      });
    }
  }, [
    smsSignUpModalFired,
    loggedIn,
    sofarStarted,
    isMultiStepSignUpShowing,
    setIsMultiStepSignUpShowing,
  ]);

  function onSmsSignUpDismiss() {
    setIsMultiStepSignUpShowing(false);
    setSmsPopupDismissedCookie();
  }

  return (
    <MultiStepSignUpWizard
      isOpen={isMultiStepSignUpShowing}
      setIsOpen={setIsMultiStepSignUpShowing}
      activeStep={2}
      formContext="sms-sign-up-modal-form"
      isLoading={isLoading}
      setIsLoading={setIsLoading}
      city={event.city}
      userEmail={user?.email}
      modalStep={ModalStep.SMS_OPT_IN}
      setModalStep={() => {}}
      onClose={onSmsSignUpDismiss}
    />
  );
};
